module.exports = __webpack_public_path__ + "assets/images/ending0_fd18563f82d16e10b4448f45fbcde9d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ending/ending0.png
// module id = 132
// module chunks = 0